// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PhotosUploadScreen":"qb_a bhh_ea bhh_qr bhh_a bhh_w"};